import React from 'react';
import { cn } from '../../../utils/cn';

const SettingsSidebar = ({ 
  tabs,
  activeTab,
  onTabChange,
  className,
  ...props 
}) => {
  return (
    <aside
      className={cn(
        // Desktop: Standard sidebar
        'hidden md:block md:w-60 md:flex-shrink-0 bg-white border-r border-gray-200',
        'overflow-y-auto',
        className
      )}
      {...props}
    >
      <nav className="p-4">
        <ul className="space-y-2">
          {tabs.map(tab => (
            <li key={tab.key}>
              <button
                onClick={() => onTabChange(tab.key)}
                className={cn(
                  'w-full flex items-center gap-3 px-4 py-3 rounded-xl',
                  'text-left font-medium transition-all duration-200',
                  'hover:bg-gray-50 active:scale-95 min-h-touch',
                  activeTab === tab.key 
                    ? 'bg-primary-50 text-primary-600 border-l-4 border-primary-500'
                    : 'text-gray-700 hover:text-gray-900'
                )}
              >
                <span className={cn(
                  'text-lg',
                  activeTab === tab.key ? 'text-primary-500' : 'text-gray-400'
                )}>
                  {tab.icon}
                </span>
                <span className="truncate">{tab.label}</span>
              </button>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
};

export default SettingsSidebar;